import React, { useEffect, useState, useRef } from "react";

function AskQuestion(props) {

  const {showMaximumChat} =props
  const [value, setValue] = useState('');
  const [selectedOption, setSelectedOption] = useState('');

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  // Handle input change
  const handleChange = (e) => {
    setValue(e.target.value);
  };

  // Handle form submission on Enter key
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent default form submission
      if (value) {
        alert(`Submitted value: ${value}`);
        // Add form submission logic here
      } else {
        alert('Please enter a number!');
      }
    }
  };
  return (
    <div>
      <div style={{ padding: "8px" }} className="header-prob">Please ask the following questions to customer</div>
      <div style={{ padding: "8px" }} className="header-prob">Ask the error message on TV or issue faced by the subscriber</div>
      <input
        id="answer"
        type="text"
        placeholder="Please type your answer"
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        required />
      <div style={{ padding: "8px" }} className="header-prob">Ask if the customer is in front of TV</div>

      <div style={{display : 'grid' , gap : '10px'}}>
        <label>
          <input
            type="radio"
            value="yes"
            checked={selectedOption === 'yes'}
            onChange={handleOptionChange}
            className="ask-radio"
          />
          Yes
        </label>
        <label>
          <input
            type="radio"
            value="no"
            checked={selectedOption === 'no'}
            onChange={handleOptionChange}
            className="ask-radio"
          />
          No
        </label>

        <div style={{ display: "flex", gap: "10px", marginTop : '20px' , marginBottom : '10px'}}>
              <button
                className="submit-wo"
                style={{ width: showMaximumChat ? "10%" : "25%" }}
              >
                Submit
              </button>
              {/* <button
                className="cancel-wo"
                style={{ width: showMaximumChat ? "10%" : "35%" }}
                onClick={() => {
                 
                }}
              >
                Cancel
              </button> */}
            </div>
      </div>
    </div>
  )
}

export default AskQuestion
